<template>
<div class="login">
  <h4>ВХОД НА САЙТ</h4>

  <h5 class="login__title">Уважаемые родители и ученики!</h5>
  <p class="login__text">
    У нас изменился договор-оферта. С актуальной версией вы можете ознакомиться
    <a href="storage/app/media/Dogovor-oferta-Genius School.pdf">по этой ссылке</a>.
    <br>Заходя на платформу, вы соглашаетесь с условиями данной оферты и принимаете правила.
  </p>
  
  <form class="login__container" @submit.prevent="sendForm">
    <p class="form__field">
      <input 
        type="text" 
        name="email" 
        class="uk-input" 
        placeholder="Введите email или номер телефона" 
        v-model="formData.email"
      >
    </p>
    
    <p class="form__field">
      <input class="uk-input" v-model="formData.password" :type="showpass ? 'text' : 'password'" placeholder="Введите пароль" autocomplete="off">
      <span class="showpass" @click="showpass = !showpass" :class="showpass ? 'active' : ''" uk-tooltip="Показать пароль"></span>
    </p>    
    
    <div class="login__buttons">
      <button class="uk-button uk-button-primary" type="submit" :disabled="!$root.confid">Войти на сайт</button>
      <div class="login__pass">
        <a href="/restore-password">Забыли пароль?</a>
      </div>
    </div>
  </form>
</div>
</template>

<script>
import Http from '../classes/http'
export default {
  props: ['email'],
  data() {
    return {
      http: new Http(this),
      showpass: false,
      formData: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    async sendForm() {
      let res = await this.http.post('Login::onAjax', this.formData).then(res => res.data)
      if (res.status === false) {
        swal('', res.message, 'warning')
      } else {
        swal({
          text: 'Данные верны. Переходим в личный кабинет...',
          icon: 'success',
          button: false,
          closeOnClickOutside: false
        })
        window.location.replace(res.X_OCTOBER_REDIRECT);
      }
    },
  }
}
</script>

